import {Component, model, ModelSignal} from '@angular/core';
import {
  CSV_IMPORT_ACTION,
  DEFAULT_TABLE_ACTIONS,
  ITableAction,
  TableControlComponent,
  TableControlModule,
} from 'frontier';
import AppControlGuids from '../../../../api/ControlGuids';

@Component({
  selector: 'app-dunning-level-import-table',
  standalone: true,
  imports: [TableControlModule],
  templateUrl: '../../../../../../projects/frontier/browserkit/src/lib/components/control/table-control/table-control.component.html',
  styleUrl: '../../../../../../projects/frontier/browserkit/src/lib/components/control/table-control/table-control.component.scss',
})
export class DunningLevelImportTableComponent extends TableControlComponent {
  override GUID: string = AppControlGuids.TDunningLevelImportView;
  override actions: ModelSignal<ITableAction[]> = model<ITableAction[]>([
    ...DEFAULT_TABLE_ACTIONS,
    CSV_IMPORT_ACTION,
  ]);
}
